
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';

@Component({})
export default class DuplicationStatusIndicator extends Vue {
  @Prop({ default: false }) hasError!: boolean;
  @Prop({ default: 25 }) iconSize!: any;
}
